/**
 * MenuManagementContainer
 * --
 */
import React, { useEffect, useState } from 'react';
import MenuRegisterPresenter from './MenuRegisterPresenter';

const categories = [
  {
    category_product_id: 1,
    // parents_id: null,
    category_product_name: '원두',
    type: 'APPROVE',
    is_show: 'Y',
    created_at: new Date(),
    updated_at: null,
    commission_id: 1,
    order: 1,
  },
  {
    category_product_id: 2,
    // parents_id: null,
    category_product_name: '디저트',
    type: 'APPROVE',
    is_show: 'Y',
    created_at: new Date(),
    updated_at: null,
    commission_id: 1,
    order: 2,
  },
];

const menus = [
  {
    menu_id: 1,
    category_product_id: 1,
    menu_name: '아메리카노(Ice)',
    menu_content:
      '무슨무슨 원두와 저런저런 원두를 선택할 수 있어서 풍미와 산뜻함을 고객님 입맛에 맞게 조절하여 주문 가능한 원두커피입니다.',
    num: 100,
    price: 5000,
    menu_code: '12341234',
    order: 1,
    menu_option: {
      기본옵션: [
        {
          option_name: 'HOT',
          option_price: 0,
        },
        {
          option_name: 'ICE',
          option_price: 0,
        },
      ],
      얼음: [
        {
          option_name: '보통(기본)',
          option_price: 0,
        },
        {
          option_name: '적게(+0원)',
          option_price: 0,
        },
        {
          option_name: '많이(+0원)',
          option_price: 0,
        },
      ],
    },
    menu_status: 'NORMAL',
    files: [
      'https://s3-alpha-sig.figma.com/img/6b1b/6d24/f5e1611c5c035b08aaf1ee085008bb99?Expires=1721001600&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=EWR3e~41fWZzveX2Eny1V3gm8GHcqqThjKVqMiFkSdFHyRPt2yS3jwmBeGhbKv2v8Hp0s1B~zjlTui1qwc8BsPP5mlOU~GVjFI0Yy5fptTM13ffAv3rWCSYuvXlO4Y528lIk5sEC5jXbFU8XHf~MXVneGXUdq0jb5nC4A4cCb2aFOYLRimpj-YAOtqSVwUfbVkJgpOxEhTIFGlLRm95CDcDcMKQ4YBUzIzhW5-6Z3qmfU1isnaJPPF-TUnT0bzup7lmo8LxtDw-8D3vmuk2~Vch1rgiUs~5t1j~o0dODEzU9~3ZwL8mvibPcqCUX9nD2yWEcCXXqKCV75c74wYA1zQ__',
      'https://s3-alpha-sig.figma.com/img/6b1b/6d24/f5e1611c5c035b08aaf1ee085008bb99?Expires=1721001600&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=EWR3e~41fWZzveX2Eny1V3gm8GHcqqThjKVqMiFkSdFHyRPt2yS3jwmBeGhbKv2v8Hp0s1B~zjlTui1qwc8BsPP5mlOU~GVjFI0Yy5fptTM13ffAv3rWCSYuvXlO4Y528lIk5sEC5jXbFU8XHf~MXVneGXUdq0jb5nC4A4cCb2aFOYLRimpj-YAOtqSVwUfbVkJgpOxEhTIFGlLRm95CDcDcMKQ4YBUzIzhW5-6Z3qmfU1isnaJPPF-TUnT0bzup7lmo8LxtDw-8D3vmuk2~Vch1rgiUs~5t1j~o0dODEzU9~3ZwL8mvibPcqCUX9nD2yWEcCXXqKCV75c74wYA1zQ__',
      'https://s3-alpha-sig.figma.com/img/6b1b/6d24/f5e1611c5c035b08aaf1ee085008bb99?Expires=1721001600&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=EWR3e~41fWZzveX2Eny1V3gm8GHcqqThjKVqMiFkSdFHyRPt2yS3jwmBeGhbKv2v8Hp0s1B~zjlTui1qwc8BsPP5mlOU~GVjFI0Yy5fptTM13ffAv3rWCSYuvXlO4Y528lIk5sEC5jXbFU8XHf~MXVneGXUdq0jb5nC4A4cCb2aFOYLRimpj-YAOtqSVwUfbVkJgpOxEhTIFGlLRm95CDcDcMKQ4YBUzIzhW5-6Z3qmfU1isnaJPPF-TUnT0bzup7lmo8LxtDw-8D3vmuk2~Vch1rgiUs~5t1j~o0dODEzU9~3ZwL8mvibPcqCUX9nD2yWEcCXXqKCV75c74wYA1zQ__',
      'https://s3-alpha-sig.figma.com/img/6b1b/6d24/f5e1611c5c035b08aaf1ee085008bb99?Expires=1721001600&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=EWR3e~41fWZzveX2Eny1V3gm8GHcqqThjKVqMiFkSdFHyRPt2yS3jwmBeGhbKv2v8Hp0s1B~zjlTui1qwc8BsPP5mlOU~GVjFI0Yy5fptTM13ffAv3rWCSYuvXlO4Y528lIk5sEC5jXbFU8XHf~MXVneGXUdq0jb5nC4A4cCb2aFOYLRimpj-YAOtqSVwUfbVkJgpOxEhTIFGlLRm95CDcDcMKQ4YBUzIzhW5-6Z3qmfU1isnaJPPF-TUnT0bzup7lmo8LxtDw-8D3vmuk2~Vch1rgiUs~5t1j~o0dODEzU9~3ZwL8mvibPcqCUX9nD2yWEcCXXqKCV75c74wYA1zQ__',
    ],
  },
  {
    menu_id: 2,
    category_product_id: 1,
    menu_name: '아메리카노(Hot)',
    menu_content:
      '무슨무슨 원두와 저런저런 원두를 선택할 수 있어서 풍미와 산뜻함을 고객님 입맛에 맞게 조절하여 주문 가능한 원두커피입니다.',
    num: 100,
    price: 4500,
    menu_code: '12341234',
    order: 2,
    menu_option: {
      기본옵션: [
        {
          option_name: 'HOT',
          option_price: 0,
        },
        {
          option_name: 'ICE',
          option_price: 0,
        },
      ],
      샷추가: [
        {
          option_name: '없음(기본)',
          option_price: 0,
        },
        {
          option_name: '1샷(+500원)',
          option_price: 500,
        },
        {
          option_name: '2샷(+800원)',
          option_price: 800,
        },
      ],
      사이즈: [
        {
          option_name: 'S(기본)',
          option_price: 0,
        },
        {
          option_name: 'M(+500원)',
          option_price: 500,
        },
        {
          option_name: 'L(+1,000원)',
          option_price: 800,
        },
      ],
      얼음: [
        {
          option_name: '보통(기본)',
          option_price: 0,
        },
        {
          option_name: '적게(+0원)',
          option_price: 0,
        },
        {
          option_name: '많이(+0원)',
          option_price: 0,
        },
      ],
    },
    menu_status: 'NORMAL',
    files: [
      'https://s3-alpha-sig.figma.com/img/6b1b/6d24/f5e1611c5c035b08aaf1ee085008bb99?Expires=1721001600&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=EWR3e~41fWZzveX2Eny1V3gm8GHcqqThjKVqMiFkSdFHyRPt2yS3jwmBeGhbKv2v8Hp0s1B~zjlTui1qwc8BsPP5mlOU~GVjFI0Yy5fptTM13ffAv3rWCSYuvXlO4Y528lIk5sEC5jXbFU8XHf~MXVneGXUdq0jb5nC4A4cCb2aFOYLRimpj-YAOtqSVwUfbVkJgpOxEhTIFGlLRm95CDcDcMKQ4YBUzIzhW5-6Z3qmfU1isnaJPPF-TUnT0bzup7lmo8LxtDw-8D3vmuk2~Vch1rgiUs~5t1j~o0dODEzU9~3ZwL8mvibPcqCUX9nD2yWEcCXXqKCV75c74wYA1zQ__',
      'https://s3-alpha-sig.figma.com/img/6b1b/6d24/f5e1611c5c035b08aaf1ee085008bb99?Expires=1721001600&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=EWR3e~41fWZzveX2Eny1V3gm8GHcqqThjKVqMiFkSdFHyRPt2yS3jwmBeGhbKv2v8Hp0s1B~zjlTui1qwc8BsPP5mlOU~GVjFI0Yy5fptTM13ffAv3rWCSYuvXlO4Y528lIk5sEC5jXbFU8XHf~MXVneGXUdq0jb5nC4A4cCb2aFOYLRimpj-YAOtqSVwUfbVkJgpOxEhTIFGlLRm95CDcDcMKQ4YBUzIzhW5-6Z3qmfU1isnaJPPF-TUnT0bzup7lmo8LxtDw-8D3vmuk2~Vch1rgiUs~5t1j~o0dODEzU9~3ZwL8mvibPcqCUX9nD2yWEcCXXqKCV75c74wYA1zQ__',
      'https://s3-alpha-sig.figma.com/img/6b1b/6d24/f5e1611c5c035b08aaf1ee085008bb99?Expires=1721001600&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=EWR3e~41fWZzveX2Eny1V3gm8GHcqqThjKVqMiFkSdFHyRPt2yS3jwmBeGhbKv2v8Hp0s1B~zjlTui1qwc8BsPP5mlOU~GVjFI0Yy5fptTM13ffAv3rWCSYuvXlO4Y528lIk5sEC5jXbFU8XHf~MXVneGXUdq0jb5nC4A4cCb2aFOYLRimpj-YAOtqSVwUfbVkJgpOxEhTIFGlLRm95CDcDcMKQ4YBUzIzhW5-6Z3qmfU1isnaJPPF-TUnT0bzup7lmo8LxtDw-8D3vmuk2~Vch1rgiUs~5t1j~o0dODEzU9~3ZwL8mvibPcqCUX9nD2yWEcCXXqKCV75c74wYA1zQ__',
      'https://s3-alpha-sig.figma.com/img/6b1b/6d24/f5e1611c5c035b08aaf1ee085008bb99?Expires=1721001600&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=EWR3e~41fWZzveX2Eny1V3gm8GHcqqThjKVqMiFkSdFHyRPt2yS3jwmBeGhbKv2v8Hp0s1B~zjlTui1qwc8BsPP5mlOU~GVjFI0Yy5fptTM13ffAv3rWCSYuvXlO4Y528lIk5sEC5jXbFU8XHf~MXVneGXUdq0jb5nC4A4cCb2aFOYLRimpj-YAOtqSVwUfbVkJgpOxEhTIFGlLRm95CDcDcMKQ4YBUzIzhW5-6Z3qmfU1isnaJPPF-TUnT0bzup7lmo8LxtDw-8D3vmuk2~Vch1rgiUs~5t1j~o0dODEzU9~3ZwL8mvibPcqCUX9nD2yWEcCXXqKCV75c74wYA1zQ__',
    ],
  },
  {
    menu_id: 3,
    category_product_id: 1,
    menu_name: '카페라떼(Ice)',
    menu_content:
      '무슨무슨 원두와 저런저런 원두를 선택할 수 있어서 풍미와 산뜻함을 고객님 입맛에 맞게 조절하여 주문 가능한 원두커피입니다.',
    num: 100,
    price: 5500,
    menu_code: '12341234',
    order: 3,
    menu_option: {
      기본옵션: [
        {
          option_name: 'HOT',
          option_price: 0,
        },
        {
          option_name: 'ICE',
          option_price: 0,
        },
      ],
      샷추가: [
        {
          option_name: '없음(기본)',
          option_price: 0,
        },
        {
          option_name: '1샷(+500원)',
          option_price: 500,
        },
        {
          option_name: '2샷(+800원)',
          option_price: 800,
        },
      ],
      사이즈: [
        {
          option_name: 'S(기본)',
          option_price: 0,
        },
        {
          option_name: 'M(+500원)',
          option_price: 500,
        },
        {
          option_name: 'L(+1,000원)',
          option_price: 800,
        },
      ],
      얼음: [
        {
          option_name: '보통(기본)',
          option_price: 0,
        },
        {
          option_name: '적게(+0원)',
          option_price: 0,
        },
        {
          option_name: '많이(+0원)',
          option_price: 0,
        },
      ],
    },
    menu_status: 'NORMAL',
    files: [
      'https://s3-alpha-sig.figma.com/img/6b1b/6d24/f5e1611c5c035b08aaf1ee085008bb99?Expires=1721001600&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=EWR3e~41fWZzveX2Eny1V3gm8GHcqqThjKVqMiFkSdFHyRPt2yS3jwmBeGhbKv2v8Hp0s1B~zjlTui1qwc8BsPP5mlOU~GVjFI0Yy5fptTM13ffAv3rWCSYuvXlO4Y528lIk5sEC5jXbFU8XHf~MXVneGXUdq0jb5nC4A4cCb2aFOYLRimpj-YAOtqSVwUfbVkJgpOxEhTIFGlLRm95CDcDcMKQ4YBUzIzhW5-6Z3qmfU1isnaJPPF-TUnT0bzup7lmo8LxtDw-8D3vmuk2~Vch1rgiUs~5t1j~o0dODEzU9~3ZwL8mvibPcqCUX9nD2yWEcCXXqKCV75c74wYA1zQ__',
      'https://s3-alpha-sig.figma.com/img/6b1b/6d24/f5e1611c5c035b08aaf1ee085008bb99?Expires=1721001600&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=EWR3e~41fWZzveX2Eny1V3gm8GHcqqThjKVqMiFkSdFHyRPt2yS3jwmBeGhbKv2v8Hp0s1B~zjlTui1qwc8BsPP5mlOU~GVjFI0Yy5fptTM13ffAv3rWCSYuvXlO4Y528lIk5sEC5jXbFU8XHf~MXVneGXUdq0jb5nC4A4cCb2aFOYLRimpj-YAOtqSVwUfbVkJgpOxEhTIFGlLRm95CDcDcMKQ4YBUzIzhW5-6Z3qmfU1isnaJPPF-TUnT0bzup7lmo8LxtDw-8D3vmuk2~Vch1rgiUs~5t1j~o0dODEzU9~3ZwL8mvibPcqCUX9nD2yWEcCXXqKCV75c74wYA1zQ__',
    ],
  },
  {
    menu_id: 4,
    category_product_id: 1,
    menu_name: '카페라떼(Hot)',
    menu_content:
      '무슨무슨 원두와 저런저런 원두를 선택할 수 있어서 풍미와 산뜻함을 고객님 입맛에 맞게 조절하여 주문 가능한 원두커피입니다.',
    num: 100,
    price: 5000,
    menu_code: '12341234',
    order: 4,
    menu_option: {
      기본옵션: [
        {
          option_name: 'HOT',
          option_price: 0,
        },
        {
          option_name: 'ICE',
          option_price: 0,
        },
      ],
      샷추가: [
        {
          option_name: '없음(기본)',
          option_price: 0,
        },
        {
          option_name: '1샷(+500원)',
          option_price: 500,
        },
        {
          option_name: '2샷(+800원)',
          option_price: 800,
        },
      ],
      사이즈: [
        {
          option_name: 'S(기본)',
          option_price: 0,
        },
        {
          option_name: 'M(+500원)',
          option_price: 500,
        },
        {
          option_name: 'L(+1,000원)',
          option_price: 800,
        },
      ],
      얼음: [
        {
          option_name: '보통(기본)',
          option_price: 0,
        },
        {
          option_name: '적게(+0원)',
          option_price: 0,
        },
        {
          option_name: '많이(+0원)',
          option_price: 0,
        },
      ],
    },
    menu_status: 'NORMAL',
    files: [
      'https://s3-alpha-sig.figma.com/img/6b1b/6d24/f5e1611c5c035b08aaf1ee085008bb99?Expires=1721001600&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=EWR3e~41fWZzveX2Eny1V3gm8GHcqqThjKVqMiFkSdFHyRPt2yS3jwmBeGhbKv2v8Hp0s1B~zjlTui1qwc8BsPP5mlOU~GVjFI0Yy5fptTM13ffAv3rWCSYuvXlO4Y528lIk5sEC5jXbFU8XHf~MXVneGXUdq0jb5nC4A4cCb2aFOYLRimpj-YAOtqSVwUfbVkJgpOxEhTIFGlLRm95CDcDcMKQ4YBUzIzhW5-6Z3qmfU1isnaJPPF-TUnT0bzup7lmo8LxtDw-8D3vmuk2~Vch1rgiUs~5t1j~o0dODEzU9~3ZwL8mvibPcqCUX9nD2yWEcCXXqKCV75c74wYA1zQ__',
      'https://s3-alpha-sig.figma.com/img/6b1b/6d24/f5e1611c5c035b08aaf1ee085008bb99?Expires=1721001600&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=EWR3e~41fWZzveX2Eny1V3gm8GHcqqThjKVqMiFkSdFHyRPt2yS3jwmBeGhbKv2v8Hp0s1B~zjlTui1qwc8BsPP5mlOU~GVjFI0Yy5fptTM13ffAv3rWCSYuvXlO4Y528lIk5sEC5jXbFU8XHf~MXVneGXUdq0jb5nC4A4cCb2aFOYLRimpj-YAOtqSVwUfbVkJgpOxEhTIFGlLRm95CDcDcMKQ4YBUzIzhW5-6Z3qmfU1isnaJPPF-TUnT0bzup7lmo8LxtDw-8D3vmuk2~Vch1rgiUs~5t1j~o0dODEzU9~3ZwL8mvibPcqCUX9nD2yWEcCXXqKCV75c74wYA1zQ__',
    ],
  },
  {
    menu_id: 5,
    category_product_id: 2,
    menu_name: 'JM브레드',
    menu_content:
      '무슨무슨 원두와 저런저런 원두를 선택할 수 있어서 풍미와 산뜻함을 고객님 입맛에 맞게 조절하여 주문 가능한 원두커피입니다.',
    num: 100,
    price: 5000,
    menu_code: '12341234',
    order: 1,
    menu_option: {
      기본옵션: [
        {
          option_name: 'HOT',
          option_price: 0,
        },
        {
          option_name: 'ICE',
          option_price: 0,
        },
      ],
      샷추가: [
        {
          option_name: '없음(기본)',
          option_price: 0,
        },
        {
          option_name: '1샷(+500원)',
          option_price: 500,
        },
        {
          option_name: '2샷(+800원)',
          option_price: 800,
        },
      ],
      사이즈: [
        {
          option_name: 'S(기본)',
          option_price: 0,
        },
        {
          option_name: 'M(+500원)',
          option_price: 500,
        },
        {
          option_name: 'L(+1,000원)',
          option_price: 800,
        },
      ],
      얼음: [
        {
          option_name: '보통(기본)',
          option_price: 0,
        },
        {
          option_name: '적게(+0원)',
          option_price: 0,
        },
        {
          option_name: '많이(+0원)',
          option_price: 0,
        },
      ],
    },
    menu_status: 'NORMAL',
    files: [],
  },
  {
    menu_id: 6,
    category_product_id: 2,
    menu_name: '기장브레드',
    menu_content:
      '무슨무슨 원두와 저런저런 원두를 선택할 수 있어서 풍미와 산뜻함을 고객님 입맛에 맞게 조절하여 주문 가능한 원두커피입니다.',
    num: 100,
    price: 5000,
    menu_code: '12341234',
    order: 2,
    menu_option: {
      기본옵션: [
        {
          option_name: 'HOT',
          option_price: 0,
        },
        {
          option_name: 'ICE',
          option_price: 0,
        },
      ],
      샷추가: [
        {
          option_name: '없음(기본)',
          option_price: 0,
        },
        {
          option_name: '1샷(+500원)',
          option_price: 500,
        },
        {
          option_name: '2샷(+800원)',
          option_price: 800,
        },
      ],
      사이즈: [
        {
          option_name: 'S(기본)',
          option_price: 0,
        },
        {
          option_name: 'M(+500원)',
          option_price: 500,
        },
        {
          option_name: 'L(+1,000원)',
          option_price: 800,
        },
      ],
      얼음: [
        {
          option_name: '보통(기본)',
          option_price: 0,
        },
        {
          option_name: '적게(+0원)',
          option_price: 0,
        },
        {
          option_name: '많이(+0원)',
          option_price: 0,
        },
      ],
    },
    menu_status: 'NORMAL',
    files: [],
  },
];

const MenuManagementContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [data, setData] = useState([]);
  const [selectedItem, setSelectedItem] = useState({});
  // 모달 open 여부
  const [isOpened, setIsOpened] = useState(false);
  // 모달 타입
  // NOTE: 순서 편집(order) / 카테고리 추가(category) / 메뉴 추가(menu)
  const [modalType, setModalType] = useState('');
  // default 입력값 / [카테고리명, 카테고리 설명], [메뉴명, 단가, 설명]
  const [inputValue, setInputValue] = useState({});
  // 메뉴 파일
  const [files, setFiles] = useState([]);
  // 메뉴 옵션
  const [options, setOptions] = useState([]);
  // 순서 편집 데이터
  const [orderList, setOrderList] = useState([]);

  /* ===== VARIABLE ===== */

  /* ===== FUNCTION ===== */
  /**
   * 모달 핸들러
   * --
   */
  const handleModal = (open, type = '') => {
    setIsOpened(!open);
    setModalType(type);
  };

  /**
   * 데이터 바인딩 함수
   * --
   */
  const handleChange = (t, v, callback = null) => {
    let newData = { ...inputValue };

    newData[t] = v;
    const d = {
      ...newData,
    };
    setInputValue(d);

    if (callback) callback(v);
  };

  /**
   * 메뉴 옵션 바인딩 함수
   * --
   */
  const handleOption = (data, index) => {
    let newData = [...options];

    newData[index] = data;
    setOptions(newData);
  };

  /**
   * 순서 드래그앤드랍 변경
   * --
   */
  const handleDrop = (updatedItems, depth = 0, parentId = null) => {
    if (depth === 0) {
      setOrderList(updatedItems);
    } else if (depth === 1) {
      const updatedData = orderList.map((cat) => {
        if (cat.category_product_id === parentId) {
          return { ...cat, menus: updatedItems };
        }
        return cat;
      });
      setOrderList(updatedData);
    }
  };

  /**
   * 순서 변경
   * --
   */
  const handleUpdateOrder = () => {
    const confirm = window.confirm(`변경한 순서를 저장하시겠습니까?`);

    if (confirm) {
      try {
        const newOrder = orderList.map((item, index) => ({
          ...item,
          order: index + 1,
          menus: item.menus.map((subitem, subindex) => ({
            ...subitem,
            order: subindex + 1,
          })),
        }));

        // TODO: 변경한 순서 저장 처리
      } catch (err) {
        console.log('순서변경 에러', err);
        throw err;
      }
    }
  };

  /* ===== HOOKS ===== */
  useEffect(() => {
    if (menus.length && categories.length) {
      const newMenus = categories.map((_item) => ({
        ..._item,
        menus: menus.filter(
          (_subitem) =>
            _item.category_product_id === _subitem.category_product_id,
        ),
      }));

      setData(newMenus);
    }
  }, []);

  /* ===== RENDER ===== */
  return (
    <>
      <MenuRegisterPresenter
        data={data}
        selectedItem={selectedItem}
        isOpened={isOpened}
        modalType={modalType}
        files={files}
        options={options}
        onSelect={setSelectedItem}
        onModal={handleModal}
        onChange={handleChange}
        onFileChange={setFiles}
        onOptionList={setOptions}
        onOptionChange={handleOption}
        onDrop={handleDrop}
        onUpdateOrder={handleUpdateOrder}
      />
    </>
  );
};

export default MenuManagementContainer;
